import { AnalyticEvent } from "../AnalyticEvent";


const EVENT_NAME = "MailChimpOpen"
export class MailChimpOpenEvent extends AnalyticEvent {

    constructor(){
        super(EVENT_NAME,{});
    }
}


const EVENT_NAME_SUB = "MailChimpSubscribe"
export class MailChimpSubscribeEvent extends AnalyticEvent {

    constructor(){
        super(EVENT_NAME_SUB ,{});
    }
}
